import { render, staticRenderFns } from "./PermissionManager.vue?vue&type=template&id=6d16b9d2&scoped=true&"
import script from "./PermissionManager.vue?vue&type=script&lang=js&"
export * from "./PermissionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d16b9d2",
  null
  
)

export default component.exports